import React, { FC, useCallback } from 'react';
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd';
import { moveItem } from 'data/cacheHelpers/menu';
import Item from './Item';
import { Props } from './types';

const Items: FC<Props> = ({
  brandId,
  categoryId,
  items,
  itemsMap,
  isProcessing,
}) => {
  const handleDragEnd = useCallback(
    ({ source, destination }: DropResult) => {
      if (!destination) {
        return;
      }
      moveItem({
        categoryId,
        from: source.index,
        to: destination.index,
        brandId,
      });
    },
    [brandId, categoryId],
  );

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId={`category-${categoryId}-items`}>
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            <div>
              {items.map(({ id, childrenEntities }, index) => (
                <Item
                  key={id}
                  index={index}
                  brandId={brandId}
                  categoryId={categoryId}
                  itemData={itemsMap[id]}
                  modifiers={childrenEntities}
                  isProcessing={isProcessing}
                />
              ))}
            </div>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default Items;
